/* global euAdminConfig */
import escape from 'lodash.escape';
import Cookies from 'js-cookie'

//if php backend thinks domain is valid
const isDomainSetAsValid = (domainName) => {
    const selector = '#menu-container a[data-domain="' + domainName + '"] .text-success';
    return !!document.querySelector(selector);
}

const isAlreadyValidatedByAjax = (domainName) => {
    return Cookies.get('validatedByAjax-' + domainName)
}

const setValidatedByAjax = (domainName) => {
    Cookies.set('validatedByAjax-' + domainName, true);
}

export const lookupQuery = (lookupType, callback) => {
    (async () => {
        let response;

        try {
            response = await fetch(`${euAdminConfig.base_uri + euAdminConfig.hostname}/dnslookup/`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: new URLSearchParams({ type: lookupType })
            });

            if (response.status === 200) {
                const data = await response.json();

                let status = 'valid';

                if (!data.valid && !data.records.length) {
                    status = 'notValid';
                }

                if (!data.valid && data.records.length) {
                    status = 'different';
                }

                callback(status, data.records);
            } else {
                callback('notFound', null);
            }
        } catch (error) {
            callback('notFound', null);
        }
    })();
};

export const lookup = (lookupType) => {
    lookupQuery(lookupType, function (result, records) {
        try {
        const status = document.querySelector('.' + lookupType + '-status');
        const content = JSON.parse(status.dataset[lookupType + 'Content'])[result];
        status.classList.add(content['class']);
        status.querySelector('.' + lookupType + '-label').textContent = content['label'];
        const statusIcon = status.querySelector('.fa');
        statusIcon.classList.remove('fa-spinner', 'fa-spin');
        statusIcon.classList.add(content['icon']);

        const record = document.querySelector('.' + lookupType + 'Record');
        if (result !== 'valid') {
            record.querySelector('.not-valid').classList.add('show-record');

            const actualRecords = document.querySelector('.' + lookupType + 'Record .actualRecords');
            if (records) {
                records.forEach(function (item, id, records) {
                    actualRecords.insertAdjacentHTML('beforeend', '<span>' + escape(item) + '</span>');
                    //if not last
                    if (id !== records.length - 1) {
                        if (lookupType === 'txt') {
                            actualRecords.insertAdjacentHTML('beforeend', '<hr>');
                        } else {
                            actualRecords.insertAdjacentHTML('beforeend', '<br>');
                        }
                    }
                });
            }

            const actualStatus = record.querySelector('.actualStatus');
            const statusTranslations = JSON.parse(actualStatus.dataset.translations);
            actualStatus.innerHTML = statusTranslations[result] ? statusTranslations[result] : '';
        } else {
            const hostnameValidated = euAdminConfig.hostname;
            if (!isAlreadyValidatedByAjax(hostnameValidated) && !isDomainSetAsValid(hostnameValidated)) {
                //set cookie for current browser session so we don't get redirect loops
                // if backend still thinks it is not validated domain
                setValidatedByAjax(hostnameValidated);
                const currLang =  window.location.pathname.split('/')[1] ?? 'en';
                //force re-validate if valid via ajax but not yet valid otherwise
                window.location = '/' + currLang + '/'  + hostnameValidated +  '/validation/validate?type=' + lookupType;
            }
            console.log('NOT appending '+lookupType+' as it is valid ');

            record.querySelector('.valid').classList.add('show-record');
        }

        record.querySelector('.modal-spinner').style.display = 'none';
        } catch (e) {
            console.log('Error in lookup', e);
        }
    })
};
